<p-tabView
  [(activeIndex)]="activeIndex"
  (onChange)="onTabChange()"
>
  <p-tabPanel
    class="mb-2"
    header="Inputs"
    [disabled]="disabledInputs"
  >
    <eea-output-project-pwc-grid
      *ngIf="activeIndex === 0"
      [isProjectOwnershipValid]="isProjectOwnershipValid"
      [inputsRowData]="inputsRowData"
      [isPwc2]="isPwc2"
    />
  </p-tabPanel>

  <p-tabPanel
    class="mb-2"
    header="Pond and Reservoir Results"
    [disabled]="disabledSummary"
  >
    <eea-output-project-pwc-grid
      *ngIf="activeIndex === 1"
      waterbodies="Pond"
      [isProjectOwnershipValid]="isProjectOwnershipValid"
      [rawData]="rawData"
      [isPwc2]="isPwc2"
    />
  </p-tabPanel>

  <p-tabPanel
    class="mb-2"
    header="WPEZ Results"
    [disabled]="disabledSummary"
    *ngIf="!isPwc2"
  >
    <eea-output-project-pwc-grid
      *ngIf="activeIndex === 2"
      waterbodies="Wetland"
      [isProjectOwnershipValid]="isProjectOwnershipValid"
      [rawData]="rawData"
    />
  </p-tabPanel>

  <p-tabPanel
    class="mb-2"
    header="TPEZ Results"
    [disabled]="disabledSummary"
    *ngIf="!isPwc2"
  >
    <eea-output-project-pwc-grid
      *ngIf="activeIndex === 3"
      waterbodies="Terrestrial"
      [isProjectOwnershipValid]="isProjectOwnershipValid"
      [rawData]="rawData"
    />

  </p-tabPanel>

</p-tabView>

<app-loading
  *ngIf="isLoading"
  class="flex align-items-center justify-content-center"
/>
